import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const EditProductColor = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const [editLeadPriority, setEditLeadPriority] = useState([]);

  useEffect(() => {
    fetchLeadPriorityEdit();
  }, []);

  const navigate = useNavigate();

  const fetchLeadPriorityEdit = async () => {
    try {
      const response = await axiosInstance.get(`/color/edit/${data.color_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response.data.data;
      console.log("fetchedData", fetchedData);
      const transformedData = {
        business_partner_id: fetchedData.business_partner_id,
        color_name: fetchedData.color_name,
        color_desc: fetchedData.color_desc,
        status: fetchedData.status == 1 ? true : false,
      };
      setFormData(transformedData); // Assuming response.data is an object
      setEditLeadPriority(fetchedData);
      console.log("fetchedData", fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    ProductColorInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const payload = {
      color_name: formData.color_name,
      color_desc: formData.color_desc,
      status: formData.status === true ? 1 : 0,
    };

    try {
      // Show confirmation dialog before making the API call
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update the record in Color?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        return;
      }

      setLoading(true); // Show loading state

      // API request to update the color
      const response = await axiosInstance.patch(
        `/color/update/${data.color_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log("Update successful!", response.data);

      // Show success alert after the update
      await showAlert({
        title: "Success",
        text: "Color updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
      });

      // Navigate after user clicks OK
      navigate(ROUTES_NAVIGATION.PRODUCTCOLORLIST);
    } catch (error) {
      console.error("Error updating color:", error);

      // Show error alert in case of failure
      const errorMessage =
        error.response?.data?.message ||
        "Failed to update color. Please try again.";
      await showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  const ProductColorInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: validations.businessPartnerId({ required: true }),
          },
        ]
      : []),
    {
      name: "color_name",
      label: "Name",
      placeholder: "Enter Color",
      type: "text",
      required: true,
      validation: validations.colour({ required: true }),
      disabled: true,
      gridClass: "col-lg-4",
    },
    {
      name: "color_desc",
      label: "Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.description({ required: true }),
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img
              src={backicon}
              alt="back"
              // onClick={() => navigate(ROUTES_NAVIGATION.PRODUCTCOLORLIST)}
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
            <span className="backbtntitle">Edit Color</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Edit Color Details
            </span>
            <DynamicForm
              validateOnMount
              formConfig={ProductColorInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              className="submit-btn"
              disabled={
                !isFormValid(ProductColorInputs, formData, validationErrors) ||
                loading
              }
              style={buttonStyle(
                ProductColorInputs,
                formData,
                validationErrors,
                loading,
              )}
              onClick={() => handleFormSubmit(formData)}
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default EditProductColor;
